<template>
  <a-spin :spinning="spinning">
    <section>
      <div class="modal-header">
        <div class="modal-title">
          <a-icon type="unordered-list" />协议签署人员
        </div>
      </div>
      <ele-table
        ref="rt"
        :columns="columns"
        :table-data="tableData"
        :total-items="totalItems"
        :current-page="pageNumber"
        :actions-type="actionsType"
        :is-full="false"
        :hide-row-selection="false"
        :hide-pagination="false"
        :layout="'total, sizes, prev, pager, next, jumper'"
        :page-sizes="[50, 100, 200]"
        @emitRefreshData="getData"
        @emitSelectChange="selectChange"
        @emitOnPageChange="updatePageChange"
        @emitShowSizeChange="updateShowSizeChange"
      >
        <!-- 按钮 -->
        <a-row :gutter="24" class="btn--container">
          <a-col class="gutter-row" :span="3">
            <a-input
              v-model="searchDto.filterText"
              :placeholder="l('请输入姓名/电话号码')"
            />
          </a-col>
          <a-col class="gutter-row" :span="5">
            <a-range-picker
              :placeholder="[l('下发时间'), l('下发时间')]"
              v-model="startToEndDate"
            />
          </a-col>
          <a-col class="gutter-row" :span="3">
            <a-select placeholder="请选择来源"  style="width: 100%" v-model="searchDto.source" allowClear>
              <a-select-option
                :value="it.value"
                v-for="(it, i) in sourceOption"
                :key="i"
              >
                {{ it.label }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col class="gutter-row" :span="5">
            <a-button type="primary" @click="search">
              {{ l("Search") }}
            </a-button>
            <a-button @click="refreshGoFirstPage"> {{ l("Reset") }}</a-button>
          </a-col>
        
        </a-row>
        <a-row>
            <a-col class="gutter-row" :span="12" align="left">
            <a-button
              @click="importData"
              :disabled="!formId"
              type="primary"
              v-if="signstatus == 0"
            >
              <a-icon type="import" />
              {{ l("导入") }}
            </a-button>
            <a-button
              @click="exportToExcel()"
              :disabled="this.totalItems <= 0"
              v-if="signstatus == 0 || signstatus == 2 || signstatus == 1"
            >
              <a-icon type="file-excel" />
              <span>{{ l("导出签署信息") }}</span>
            </a-button>
            <a-button @click="exportToRevocationExcel()">
              <a-icon type="file-excel" />
              <span>{{ l("导出撤销信息") }}</span>
            </a-button>
            <a-dropdown v-if="signstatus === 3">
              <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item key="1">
                  <a-icon type="exception" />设置无需盖章</a-menu-item
                >
                <a-menu-item key="2">
                  <a-icon
                    type="vertical-align-bottom"
                  />导出无需盖章信息</a-menu-item
                >
              </a-menu>
              <a-button style="margin-left: 8px"
                >无需盖章（{{ NotSealCount }}人）<a-icon type="down" />
              </a-button>
            </a-dropdown>
            <a-button
              type="danger"
              style="margin-left: 8px"
              @click="exportContentToExcel()"
              :disabled="this.totalItems <= 0"
            >
              <a-icon type="cloud-download" />
              <span>{{ l("导出协议内容") }}</span>
            </a-button>
            <a-button
              style="margin-left: 8px"
              @click="exportContentToZip()"
              :disabled="this.totalItems <= 0"
              v-if="signstatus === 2"
            >
              <a-icon type="cloud-download" />
              <span>{{ l("下载协议") }}</span>
            </a-button>
            <a-button @click="notification()" v-if="signstatus == 0">
              <a-icon type="notification" />
              {{ l("批量通知签署") }}
            </a-button>
            <a-button @click="batchDelData()" v-if="signstatus == 0">
              <a-icon type="delete" />
              {{ l("批量撤回") }}
            </a-button>
          </a-col>
        </a-row>
      </ele-table>
    </section>
    <a-modal
      v-model="showNoSignModal"
      title="提示：是否无需盖章"
      @ok="handleSaveNotSign"
      okText="确认"
      cancelText="取消"
      :width="550"
    >
      <div style="width: 95%; margin: 0 auto; text-align: center">
        <div style="text-align: left; text-indent: 5px; margin-bottom: 15px">
          请选择原因：
          <a-radio-group
            :options="['误扫', '闪离', '其他']"
            :value="notSignInfo.reason"
            @change="radioReasonChange"
          ></a-radio-group>
        </div>
        <div v-show="showTextArea">
          <a-textarea
            ref="notSealTextArea"
            placeholder="输入其他原因"
            :rows="4"
            v-model="notSignInfo.textAreaReason"
          />
        </div>
      </div>
    </a-modal>
  </a-spin>
</template>
<script>
import { AppComponentBase, ModalComponentBase } from "@/shared/component-base";
import { CommonServiceProxy } from "@/shared/common-service";
import { AppConsts } from "@/abpPro/AppConsts";
import { environment } from "@/environments/environment";
import EleTable from "@/components/ele-table";
import ReactModify from "@/components/react-modify";
import EmailNotification from "@/components/react-email";
import { ModalHelper } from "@/shared/helpers";
import moment from "moment";
import ImportForm from "../importform.vue";
import { fileDownloadService } from "@/shared/utils";
import { appSessionService } from "@/shared/abp";
import { Modal } from "ant-design-vue";
export default {
  name: "signperson-list",
  mixins: [AppComponentBase, ModalComponentBase],
  components: { EleTable },
  data() {
    return {
      filterText: "",
      spinning: false,
      showNoSignModal: false,
      showTextArea: true,
      notSignInfo: {
        reason: "其他",
        textAreaReason: null,
        ids: [],
      },
      sourceOption: [
        { label: "全部", value: null },
        { label: "后台添加", value: 1 },
        { label: "小程序注册", value: 2 },
        { label: "后台导入", value: 4 },
        { label: "批量导入", value: 5 },
        { label: "H5注册", value: 6 },
        { label: "第三方电子签", value: 7  },
         { label: "招聘系统", value: 8  },
      ],
      NotSealCount: 0,
      // 表单
      formLayout: "horizontal",
      isDisabled: false,
      tableKey: "",
      commonService: null,
      personnelService: null,
      startToEndDate: [],
      
      tableData: [],
      // 总数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 共多少页
      totalPages: 1,
      // 条数显示范围
      pagerange: [1, 1],
      // 显示条数
      pageSizeOptions: ["10", "20", "30", "40"],
      actionsType: {},
      signStatuList: ["未签署", "单方签署", "已经签署", "归档", "已通知"],
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 16,
        },
      },
      // 用户表格
      columns: [
        {
          title: this.l("姓名"),
          dataIndex: "realName",
          // sorter: true,
          align: "center",
          scopedSlots: { customRender: "realName" },
        },
        {
          title: this.l("身份证号"),
          dataIndex: "idCard",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "idCard" },
        },
        {
          title: this.l("手机号"),
          dataIndex: "phoneNumber",
          // sorter: true,
          align: "center",
          scopedSlots: { customRender: "phoneNumber" },
        },
        {
          title: this.l("通知状态"),
          dataIndex: "enumSignStatusName",
          // sorter: true,
          align: "center",
          // customRender: function (text, record, index) {
          // return text == 0 ? "未签署" : "已签署";
          // },
          scopedSlots: { customRender: "enumSignStatusName" },
        },
        {
          title: this.l("发起人"),
          dataIndex: "name",
          // sorter: true,
          align: "center",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.l("协议下发时间"),
          dataIndex: "creationTime",
          //sorter: true,
          align: "center",
          scopedSlots: { customRender: "creationTime" },
        },
        {
          title: this.l("协议最后通知时间"),
          dataIndex: "lastNoticedTime",
          // sorter: true,
          align: "center",
          scopedSlots: { customRender: "lastNoticedTime" },
        },
        {
          title: this.l("协议签署时间"),
          dataIndex: "signTime",
          //sorter: true,
          align: "center",
          scopedSlots: { customRender: "signTime" },
        },
        {
          title: this.l("拒签时间"),
          dataIndex: "rejectTime",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "rejectTime" },
        },
        {
          title: this.l("通知次数"),
          dataIndex: "noticedTimeSummary",
          //sorter: true,
          align: "center",
          scopedSlots: { customRender: "projectName" },
        },
        {
          title: this.l("Actions"),
          dataIndex: "actions",
          fixed: "right",
          sorter: true,
          align: "center",
          scopedSlots: { customRender: "actions" },
        },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      searchDto: {
        agreementTemplateId: "",
        projectId: null,
        signStatus: "",
        filterText: "",
        sorting: "",
        MaxResultCount: 50,
        SkipCount: 0,
        source:null,
      },
      projectData: [
        {
          value: null,
          text: "请选择",
        },
      ],
    };
  },
  created() {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
    this.fullData(); // 模态框必须,填充数据到data字段
    this.uploadUrl = AppConsts.uploadBaseUrl + "/API/Upload";
    this.subdirName = environment.production ? "abpProd" : "abpDev";
  },
  mounted() {
    // console.log(this);
    if (this.params) {
      this.$nextTick(() => {});
    }
    this.getData();
    this.initActionsType();
    this.getNotSealPersonCount();
  },
  methods: {
    search() {
      this.pageNumber = 1;
      this.searchDto.SkipCount = 0;
      this.getData();
    },
    exportContentToZip() {
      let msg = "是否打包下载全部项目人员的协议？";
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        msg = `已选择${this.selectedRowKeys.length}条记录，是否打包下载项目人员协议？`;
      }
      const that = this;
      Modal.confirm({
        title: "提示",
        content: msg,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          that.spinning = true;
          const data = {
            projectAgreementId: that.signPerson.id,
            signStatus: that.signstatus,
            source:that.searchDto.source,
            filterText: that.searchDto.filterText,
            startDate: (that.searchDto.StartDate =
              that.startToEndDate[0] === null
                ? undefined
                : that.startToEndDate[0]),
            endDate: (that.searchDto.EndDate =
              that.startToEndDate[1] === null
                ? undefined
                : that.startToEndDate[1]),
            ids:
              that.selectedRowKeys && that.selectedRowKeys.length > 0
                ? [...that.selectedRowKeys]
                : null,
          };
          that.commonService
            .post({
              url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/ExportPersonAgreements",
              params: data,
            })
            .then((res) => {
              that.$message.success(res);
            })
            .finally(() => {
              that.spinning = false;
            });
        },
      });
    },
    async _handAutoSign(eleAgreementId) {
      try {
        this.spinning = true;
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectAgreement/HandAutoSign",
          params: {
            id: eleAgreementId,
          },
        });
        this.refreshGoFirstPage();
        this.$notification["success"]({
          message: "手动盖章完成",
        });
        this.spinning = false;
      } catch (err) {
        this.spinning = false;
      }
    },
    async getData() {
      this.spinning = true;
      this.$nextTick(() => {
        this.$refs.rt.clearData();
      });
      try {
        const params = {
          projectAgreementId: this.signPerson.id,
          signStatus: this.signstatus,
          filterText: this.searchDto.filterText,
          sorting: this.searchDto.sorting,
          source:this.searchDto.source,
          startDate: (this.searchDto.StartDate =
            this.startToEndDate[0] === null
              ? undefined
              : this.startToEndDate[0]),
          endDate: (this.searchDto.EndDate =
            this.startToEndDate[1] === null
              ? undefined
              : this.startToEndDate[1]),
          maxResultCount: this.searchDto.MaxResultCount,
          skipCount: this.searchDto.SkipCount,
        };
        // console.log(params);
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetPaged",
          params,
        });
        this.tableData = res.items.map((item) => {
          return {
            ...item,
            creationTime: moment(item.creationTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            lastNoticedTime: item.lastNoticedTime
              ? moment(item.lastNoticedTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
            signTime: item.signTime
              ? moment(item.signTime).format("YYYY-MM-DD HH:mm:ss")
              : "-",
          };
        });
        this.totalItems = res.totalCount;
        this.totalPages = Math.ceil(
          res.totalCount / this.SearchDto.MaxResultCount
        );
        this.pagerange = [
          (this.pageNumber - 1) * this.SearchDto.MaxResultCount + 1,
          this.pageNumber * this.SearchDto.MaxResultCount,
        ];
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    initActionsType() {
      let _this = this;
      let obj = {
        type: "templete-list",
        isShow: true,
        fns: {
          dropList: [],
        },
      };
      if (this.signstatus == 2) {
        obj.fns.dropList = [
          {
            granted: true,
            name: this.l("预览协议"),
            icon: "eye",
            fn: (data) => {
              console.log(data);
              if (data.viewUrl) {
                window.open(data.viewUrl);
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
          {
            granted: true,
            name: this.l("下载协议"),
            icon: "download",
            fn: (data) => {
              if (data.downloadUrl) {
                // var realName = data.realName;
                // var agreementName = data.agreementName;
                if (appSessionService.tenantId == null) {
                  window.location.href = `${AppConsts.remoteServiceBaseUrl}/api/services/app/UnnaturalPersonProjectPersonnelAgreement/DownLoadFile?id=${data.id}`;
                } else {
                  window.location.href = `${AppConsts.remoteServiceBaseUrl}/api/services/app/UnnaturalPersonProjectPersonnelAgreement/DownLoadFile?id=${data.id}&tenantId=${appSessionService.tenantId}`;
                }

                // _this.getDownloadUrl("http://localhost:6298/api/services/app/UnnaturalPersonProjectPersonnelAgreement/UploadFile?url=1&fileName=2").then(blob => {
                //   _this.saveAs(blob,"测试.pdf");
                // })
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
        ];
        obj.fns.dropList.push({
          granted: true,
          name: this.l("邮箱通知"),
          icon: "notification",
          fn: (data) => {
            _this.emailNotification(data, "edit");
          },
        });
      }
      if (this.signstatus == 1) {
        obj.fns.dropList = [
          // {
          // granted: true,
          // name: this.l("盖章"),
          // icon: "book",
          // fn: (data) => {
          // if (data.electronicAgreementId == null) {
          // this.$message.error("用户还未发起签署，无法盖章");
          // return;
          // }
          // abp.message.confirm("是否确定盖章？", "提示", (result) => {
          // if (result) {
          // _this._handAutoSign(data.electronicAgreementId);
          // }
          // });
          // },
          // },
          {
            granted: true,
            name: this.l("预览协议"),
            icon: "eye",
            fn: (data) => {
              console.log(data);
              if (data.viewUrl) {
                window.open(data.viewUrl);
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
          {
            granted: true,
            name: this.l("下载协议"),
            icon: "download",
            fn: (data) => {
              if (data.downloadUrl) {
                window.location.href = data.downloadUrl;
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
        ];
        obj.fns.dropList.push({
          granted: true,
          name: this.l("邮箱通知"),
          icon: "notification",
          fn: (data) => {
            _this.emailNotification(data, "edit");
          },
        });
      }
      if (this.signstatus == 0) {
        obj.fns.dropList = [
          {
            granted: true,
            name: this.l("通知签署"),
            icon: "notification",
            fn: (data) => {
              if (data.isNoty) {
                _this.$message.info("已通知过!");
                return;
              }
              let personnelIds = [];
              personnelIds.push(data.personnelId);
              _this.notificationPersonnelAgreement(personnelIds);
            },
          },
          {
            granted: true,
            name: this.l("撤回"),
            icon: "delete",
            fn: (data) => {
              console.log(data);
              let personnelIds = [];
              personnelIds.push(data.personnelId);
              _this.delPersonnelAgreement(personnelIds);
            },
          },
        ];
        if (this.formId) {
          obj.fns.dropList.push({
            granted: true,
            name: this.l("扩展信息"),
            icon: "profile",
            fn: (data) => {
              _this.createReactModify(data, "edit");
            },
          });
        }
      }
      if (this.signstatus == 3) {
        obj.fns.dropList = [
          {
            granted: true,
            name: this.l("盖章"),
            icon: "book",
            fn: (data) => {
              if (data.electronicAgreementId == null) {
                this.$message.error("用户还未发起签署，无法盖章");
                return;
              }
              abp.message.confirm("是否确定盖章？", "提示", (result) => {
                if (result) {
                  _this._handAutoSign(data.electronicAgreementId);
                }
              });
            },
          },
          {
            granted: true,
            name: this.l("无需盖章"),
            icon: "exception",
            fn: (data) => {
              _this.notSignInfo.ids.splice(0, _this.notSignInfo.ids.length);
              _this.notSignInfo.ids.push(data.id);
              _this.notSignInfo.textAreaReason = "";
              _this.notSignInfo.reason = "误扫";
              _this.showTextArea = false;
              _this.showNoSignModal = true;
            },
          },
          {
            granted: true,
            name: this.l("预览协议"),
            icon: "eye",
            fn: (data) => {
              console.log(data);
              if (data.viewUrl) {
                window.open(data.viewUrl);
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
          {
            granted: true,
            name: this.l("下载协议"),
            icon: "download",
            fn: (data) => {
              if (data.downloadUrl) {
                window.location.href = data.downloadUrl;
              } else {
                _this.$message.info("暂无协议");
              }
            },
          },
        ];
        obj.fns.dropList.push({
          granted: true,
          name: this.l("邮箱通知"),
          icon: "notification",
          fn: (data) => {
            _this.emailNotification(data, "edit");
          },
        });
      }
      this.actionsType = obj;
    },
    handleSaveNotSign() {
      if (!this.notSignInfo.ids || this.notSignInfo.ids.length <= 0) {
        abp.message.error("参数错误");
        return false;
      }
      let reason = this.notSignInfo.reason;
      if (this.notSignInfo.reason === "其他") {
        if (this.notSignInfo.textAreaReason === "") {
          abp.message.warn("请填写其他原因");
          return false;
        }
        reason = this.notSignInfo.textAreaReason;
      }

      this.spinning = true;
      this.commonService
        .post({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/NoNeedSign",
          params: {
            ids: this.notSignInfo.ids,
            reason: reason,
          },
        })
        .then((res) => {
          this.spinning = false;
          abp.message.success("操作成功");
          this.getData();
          this.getNotSealPersonCount();
          this.showNoSignModal = false;
        })
        .catch((e) => {
          this.spinning = false;
          console.error(e);
        });
    },
    getNotSealPersonCount() {
      this.commonService
        .get({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetNotSealCount",
          params: {
            projectAgreementId: this.signPerson.id,
          },
        })
        .then((res) => {
          console.warn(res);
          this.NotSealCount = res;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    handleMenuClick(e) {
      if (e.key === "1") {
        this.handleBatchNotSign();
      } else {
        this.handleExportNotSign();
      }
    },
    handleBatchNotSign() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length <= 0) {
        abp.message.warn("至少选择一条记录");
        return false;
      }
      this.notSignInfo.ids.splice(0, this.notSignInfo.ids.length);
      const that = this;
      this.selectedRowKeys.map((it) => {
        that.notSignInfo.ids.push(it);
        return null;
      });
      this.notSignInfo.textAreaReason = "";
      this.notSignInfo.reason = "误扫";
      this.showTextArea = false;
      this.showNoSignModal = true;
    },
    handleExportNotSign() {
      this.spinning = true;
      this.commonService
        .get({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/ExportNotSealList",
          params: {
            projectAgreementId: this.signPerson.id,
          },
        })
        .then((res) => {
          this.spinning = false;
          if (!res.success) {
            this.$message.error(res.message);
            return;
          }
          fileDownloadService.downloadTempFile(res.data);
        })
        .catch((e) => {
          this.spinning = false;
          console.error(e);
        });
    },
    radioReasonChange(e) {
      if (e.target.value === "其他") {
        this.showTextArea = true;
      } else {
        this.showTextArea = false;
      }
      this.notSignInfo.reason = e.target.value;
    },
    async emailNotification(item, type) {
      ModalHelper.create(
        EmailNotification,
        {
          params: {
            id: item.id,
            realName: item.realName,
          },
        },
        {
          isChange: true,
          width: "1200px",
        }
      ).subscribe((res) => {
        if (res) {
          this.refreshGoFirstPage();
        }
      });
    },
    /**
     * 导出为excel
     */
    async exportToRevocationExcel() {
      this.spinning = true;
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetPageDataExcelFileForRevocation",
          params: {
            projectAgreementId: this.signPerson.id,
            signStatus: this.signstatus,
            filterText: this.searchDto.filterText,
            sorting: this.searchDto.sorting,
            source:this.searchDto.source,
            startDate: (this.searchDto.StartDate =
              this.startToEndDate[0] === null
                ? undefined
                : this.startToEndDate[0]),
            endDate: (this.searchDto.EndDate =
              this.startToEndDate[1] === null
                ? undefined
                : this.startToEndDate[1]),
            maxResultCount: this.searchDto.MaxResultCount,
            skipCount: this.searchDto.SkipCount,
          },
        });
        console.log(res);
        fileDownloadService.downloadTempFile(res);
        this.spinning = false;
      } catch (error) {
        console.log(error);
        this.spinning = false;
      }
    },
    /**
     * 导出为excel
     */
    async exportToExcel() {
      this.spinning = true;
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetPageDataExcelFile",
          params: {
            projectAgreementId: this.signPerson.id,
            signStatus: this.signstatus,
            filterText: this.searchDto.filterText,
            sorting: this.searchDto.sorting,
            source:this.searchDto.source,
            startDate: (this.searchDto.StartDate =
              this.startToEndDate[0] === null
                ? undefined
                : this.startToEndDate[0]),
            endDate: (this.searchDto.EndDate =
              this.startToEndDate[1] === null
                ? undefined
                : this.startToEndDate[1]),
            maxResultCount: this.searchDto.MaxResultCount,
            skipCount: this.searchDto.SkipCount,
          },
        });
        console.log(res);
        fileDownloadService.downloadTempFile(res);
        this.spinning = false;
      } catch (error) {
        console.log(error);
        this.spinning = false;
      }
    },
    /*
     * 导出合同内容
     */
    async exportContentToExcel() {
      this.spinning = true;
      let mySignStatus;
      if (this.signstatus === 2) {
        mySignStatus = 3;
      } else if (this.signstatus === 1) {
        mySignStatus = 1;
      } else if (this.signstatus === 3) {
        mySignStatus = 2;
      }
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetPageContractContentExcel",
          params: {
            projectAgreementId: this.signPerson.id,
            signStatus: mySignStatus,
            filterText: this.searchDto.filterText,
            sorting: this.searchDto.sorting,
            source:this.searchDto.source,
            startDate: (this.searchDto.StartDate =
              this.startToEndDate[0] === null
                ? undefined
                : this.startToEndDate[0]),
            endDate: (this.searchDto.EndDate =
              this.startToEndDate[1] === null
                ? undefined
                : this.startToEndDate[1]),
            maxResultCount: this.searchDto.MaxResultCount,
            skipCount: this.searchDto.SkipCount,
          },
        });
        console.log(res);
        fileDownloadService.downloadTempFile(res);
        this.spinning = false;
      } catch (error) {
        console.log(error);
        this.spinning = false;
      }
    },
    clearFilterAndRefresh() {
      this.SearchDto.SkipCount = 0;
      this.getData();
    },
    async createReactModify(item, type) {
      let list = [];
      const orginListLength = list.length;
      let reqParams = [];
      if (item && item.personnelId) {
        // console.log(item)
        reqParams.push({ key: "id", value: item.id });
        reqParams.push({ key: "personnelId", value: item.personnelId });
        reqParams.push({ key: "formId", value: this.formId });
      }
      let otherPrams = {};
      ModalHelper.create(
        ReactModify,
        {
          params: {
            type: type, // edit,preview,create
            data: list,
            reqParams: [...reqParams],
            reqUrl: {
              getById:
                "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/GetAgreementContentInfo",
              save: "/api/services/app/UnnaturalPersonProjectPersonnelAgreement/SaveAgreementContentInfo",
            },
            otherParams: {},
            getItemfn: async (res, form, options) => {
              res.formItems.map((_item, index) => {
                switch (_item.itemType) {
                  case "Text":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "commonInput",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [
                        { max: _item.maxLength, message: this.l("MaxLength") },
                      ],
                      span: 24,
                      changeFn: () => {},
                    });
                    break;
                  case "Textarea":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "textarea",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [
                        { max: _item.maxLength, message: this.l("MaxLength") },
                      ],
                      span: 24,
                      defaultValue: "",
                      changeFn: () => {},
                    });
                    break;
                  case "Number":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "numberInput",
                      disabled: false,
                      required: _item.isRequire,
                      max: _item.maxLength,
                      min: 0,
                      key: _item.key,
                      rules: [],
                      span: 24,
                      changeFn: () => {},
                    });
                    break;
                  case "Select":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "commonSelect",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [{ required: true, message: _item.remark }],
                      span: 24,
                      defaultSelectList:
                        _item.options === "[]" ? [] : JSON.parse(_item.options),
                      changeFn: () => {},
                    });
                    break;
                  case "Checkbox":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "checkbox",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [{ required: true, message: _item.remark }],
                      span: 24,
                      defaultSelectList:
                        _item.options === "[]" ? [] : JSON.parse(_item.options),
                      changeFn: () => {},
                    });
                    break;
                  case "Radio":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "radio",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [{ required: true, message: _item.remark }],
                      span: 24,
                      defaultSelectList:
                        _item.options === "[]" ? [] : JSON.parse(_item.options),
                      changeFn: () => {},
                    });
                    break;
                  case "Date":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "datePicker",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: _item.remark,
                        },
                      ],
                      span: 24,
                      changeFn: () => {},
                    });
                    break;
                  case "Upload":
                    list.push({
                      label: _item.name,
                      value: [],
                      type: "upload",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [],
                      subdirName: environment.production ? "abpProd" : "abpDev",
                      uploadUrl: AppConsts.uploadBaseUrl + "/API/Upload",
                      limitedLength: _item.maxLength,
                      span: 24,
                      changeFn: (info) => {
                        let fileList = [...info.fileList];
                        fileList = fileList.map((file) => {
                          if (file.response) {
                            file.url = `${AppConsts.uploadBaseUrl}${file.response.data.Path}`;
                          }
                          return file;
                        });
                        list[_item.sort + orginListLength].value = fileList;
                      },
                    });
                    break;
                  case "DateRange":
                    list.push({
                      label: _item.name,
                      value: _item.key,
                      type: "rangeDatePicker",
                      disabled: false,
                      required: _item.isRequire,
                      key: _item.key,
                      rules: [
                        {
                          type: "array",
                          required: true,
                          message: _item.remark,
                        },
                      ],
                      span: 24,
                      changeFn: () => {},
                    });
                    break;
                  default:
                    throw new Error("暂无匹配项目");
                }
              });
              // console.info(item)
              // if (!item) {
              // form.setFieldsValue({
              // ProjectCode: await this._getProjectCode(),
              // });
              // } else {
              // form.setFieldsValue({
              // ProjectName: item.projectName,
              // ProjectType: item.projectType,
              // OrganizationUnitId: item.organizationUnitId,
              // ProjectTime: [item.beginDate, item.endDate],
              // CustomerName: item.customerName,
              // ProjectCode: item.projectCode,
              // });
              // }
              if (res.results && Object.keys(res.results).length !== 0) {
                const oResult = res.results;
                let opts = {};
                list.map((it) => {
                  if (it.key) {
                    let k = it.key;
                    let ores = oResult[k];
                    if (!ores) {
                      return;
                    }
                    if (it.type === "upload") {
                      if (oResult[k].value.indexOf(",") !== -1) {
                        let arr = oResult[k].value.split(",");
                        arr.map((val, i) => {
                          let n = val.split("/");
                          it.value.push({
                            uid: `-${i + 1}`,
                            url: `${AppConsts.uploadBaseUrl}${val}`,
                            name: n[n.length - 1],
                            response: { data: { Path: val } },
                            status: "done",
                          });
                        });
                      } else {
                        if (oResult[k].value && oResult[k].value.length) {
                          let n = oResult[k].value.split("/");
                          it.value.push({
                            uid: `-1`,
                            url: `${AppConsts.uploadBaseUrl}${res.pictureUrls}`,
                            name: n[n.length - 1],
                            response: { data: { Path: res.pictureUrls } },
                            status: "done",
                          });
                        }
                      }
                    } else if (it.type === "rangeDatePicker") {
                      opts[`${k}`] =
                        oResult[k].value.indexOf("至") === -1
                          ? [oResult[k].value]
                          : oResult[k].value.split("至");
                    } else if (it.type === "datePicker") {
                      opts[`${k}`] = oResult[k].value
                        ? moment(oResult[k].value, "YYYY-MM-DD")
                        : null;
                    } else if (it.type === "checkbox") {
                      opts[`${k}`] =
                        oResult[k].value.indexOf(",") === -1
                          ? [oResult[k].value]
                          : oResult[k].value.split(",");
                    } else {
                      opts[`${k}`] = oResult[k].value;
                    }
                  }
                });
                // console.log(opts)
                this.$nextTick(() => {
                  form.setFieldsValue({ ...opts });
                });
              }
              if (options) {
                // ...
              }
            },
            submitfn: async (values, queryParams) => {
              let fileUrl = [];
              for (let i = 0; i < list.length; i++) {
                if (list[i].type === "upload" && list[i].required) {
                  if (!list[i].value.length) {
                    this.$message.info(`请上传${list[i].label}的附件资源`);
                    break;
                  }
                }
              }
              let obj = {};
              queryParams.reqParams.map((item) => {
                obj[item.key] = item.value;
              });
              Object.assign(values, obj);
              let dynamicList = list.filter((item) => item.key);
              let _results = [];
              // console.log(dynamicList);
              dynamicList.map((_item) => {
                if (
                  _item.type === "commonInput" ||
                  _item.type === "numberInput" ||
                  _item.type === "textarea" ||
                  _item.type === "radio" ||
                  _item.type === "commonSelect"
                ) {
                  _results.push({
                    key: _item.key,
                    value: {
                      label: _item.label,
                      value: values[`${_item.value}`],
                    },
                  });
                } else if (_item.type === "datePicker") {
                  _results.push({
                    key: _item.key,
                    value: {
                      label: _item.label,
                      // value: values[`${_item.value}`].format('YYYY-MM-DD')
                      value: values[`${_item.value}`],
                    },
                  });
                } else if (_item.type === "rangeDatePicker") {
                  _results.push({
                    key: _item.key,
                    value: {
                      label: _item.label,
                      value:
                        values[`${_item.value}`][0] +
                        "至" +
                        values[`${_item.value}`][1],
                    },
                  });
                } else if (_item.type === "checkbox") {
                  _results.push({
                    key: _item.key,
                    value: {
                      label: _item.label,
                      value:
                        values[`${_item.value}`].length === 1
                          ? values[`${_item.value}`][0]
                          : values[`${_item.value}`].join(","),
                    },
                  });
                } else if (_item.type === "upload") {
                  _results.push({
                    key: _item.key,
                    value: {
                      label: _item.label,
                      value:
                        _item.value.length === 1
                          ? `${_item.value[0].response.data.Path}`
                          : _item.value
                              .map((v) => {
                                return v.response.data.Path;
                              })
                              .join(","),
                    },
                  });
                }
              });
              let submitData = {
                personnelId: item && item.personnelId ? item.personnelId : null,
                formId: this.formId,
                results: _results,
              };
              // console.log('submitData:', submitData)
              try {
                let res = await this.commonService.post({
                  url: queryParams.reqUrl.save,
                  params: { ...submitData },
                });
                return true;
              } catch (error) {
                return false;
              }
            },
          },
        },
        {
          isChange: true,
          width: "800px",
        }
      ).subscribe((res) => {
        if (res) {
          this.clearFilterAndRefresh();
        }
      });
    },
    // 清除条件并刷新
    clearFilterAndRefresh() {
      this.refreshGoFirstPage();
    },
    /**
     * 重置
     */
    refreshGoFirstPage() {
      this.searchDto.filterText = "";
      this.startToEndDate = [];
      this.getData();
    },
    delPersonnelAgreement(personnelIds) {
      let _that = this;
      this.message.confirm("是否确定撤回", (res) => {
        if (res) {
          _that.delData(personnelIds);
        }
      });
    },
    batchDelData() {
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "撤回"));
        return;
      }
      console.log(this.selectedRowKeys);
      console.log(this.selectedRows);
      let personnelIds = this.selectedRows.map((item) => {
        return item.personnelId;
      });
      let projectAgreementId = this.selectedRows.map((item) => {
        return item.id;
      });
      let projectAgreementIdArr = projectAgreementId.filter(function (
        item,
        index,
        projectAgreementId
      ) {
        return projectAgreementId.indexOf(item, 0) === index;
      });
      let _that = this;
      _that.message.confirm(
        `是否对${personnelIds.length}个人进行撤回`,
        "撤回",
        (res) => {
          if (res) {
            _that.delData(personnelIds);
          }
        }
      );
    },
    async delData(personnelIds) {
      this.spinning = true;
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonAgreementTemplate/Revocation",
          params: {
            projectAgreementId: this.signPerson.id,
            personnelIds: personnelIds,
          },
        });
        this.refreshGoFirstPage();
        this.$notification["success"]({
          message: res,
        });
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    batchDownload() {
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "下载"));
        return;
      }
    },
    notification() {
      console.log(this.selectedRowKeys);
      const selectCount = this.selectedRowKeys.length;
      if (selectCount <= 0) {
        abp.message.warn(this.l("PleaseSelectAXPlaceHolder", "通知签署"));
        return;
      }
      console.log(this.selectedRowKeys);
      console.log(this.selectedRows);
      let personnelIds = this.selectedRows.map((item) => {
        return item.personnelId;
      });
      let projectAgreementId = this.selectedRows.map((item) => {
        return item.id;
      });
      let projectAgreementIdArr = projectAgreementId.filter(function (
        item,
        index,
        projectAgreementId
      ) {
        return projectAgreementId.indexOf(item, 0) === index;
      });
      let _that = this;
      _that.message.confirm(
        `是否对${personnelIds.length}个人进行通知签署`,
        "系统提示",
        (res) => {
          if (res) {
            _that.notificationData(personnelIds);
          }
        }
      );
    },
    notificationPersonnelAgreement(personnelIds) {
      let _that = this;
      this.message.confirm("是否确定通知签署", (res) => {
        if (res) {
          _that.notificationData(personnelIds);
        }
      });
    },
    importData() {
      ModalHelper.create(
        ImportForm,
        { formId: this.formId },
        {
          width: "500px",
        }
      ).subscribe((res) => {
        this.refreshGoFirstPage();
      });
    },
    async notificationData(personnelIds) {
      this.spinning = true;
      try {
        let res = await this.commonService.post({
          url: "/api/services/app/UnnaturalPersonAgreementTemplate/SendSignNotice",
          params: {
            projectAgreementId: this.signPerson.id,
            personnelIds: personnelIds,
          },
        });
        this.refreshGoFirstPage();
        console.log(res);
        this.$notification["success"]({
          message: res,
        });
        this.spinning = false;
      } catch (error) {
        this.spinning = false;
      }
    },
    selectChange(data) {
      let { selectedRowKeys, selectedRows } = data;
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    handleChange(value) {
      this.searchDto.projectId = value;
      // console.log(value);
    },
    updatePageChange(newV) {
      let { page, pageSize } = newV;
      this.onChange(page, pageSize);
    },
    onChange(page, pageSize) {
      this.pageNumber = page;
      this.searchDto.SkipCount = (page - 1) * this.searchDto.MaxResultCount;
      this.getData();
    },
    updateShowSizeChange(newV) {
      let { current, size } = newV;
      this.showSizeChange(current, size);
    },
    showSizeChange(current, size) {
      this.pageNumber = 1;
      this.searchDto.MaxResultCount = size;
      this.getData();
    },
    getDownloadUrl(url) {
      return new Promise((resolve) => {
        const xml = new XMLHttpRequest();
        xml.open("GET", url, true);
        xml.responseType = "blob";
        xml.onload = () => {
          if (xml.status === 200) {
            resolve(xml.response);
          }
        };
        xml.send();
      });
    },
    saveAs(url, fileName) {
      const elelink = document.createElement("a");
      elelink.style.display = "none";
      elelink.download = fileName;
      elelink.href = window.URL.createObjectURL(url);
      document.body.appendChild(elelink);
      elelink.click();
      document.body.removeChild(elelink);
    },
  },
};
</script>
<style scoped lang="less">
// @import "../../../../styles/common.less";
.modal-header {
  .anticon-share-alt {
    margin-right: 10px;
  }
}

.form-wrapper {
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>